<ion-content class="modal-border">
  <ion-header>
    <ion-toolbar> </ion-toolbar>
  </ion-header>

  <div class="ion-padding">
    <div *ngIf="loadingDone == false">
      <ion-label>Loading in progress, please wait...</ion-label>
      <ion-progress-bar type="indeterminate"></ion-progress-bar>
    </div>

    <div *ngIf="loadingDone == true">
      <ion-item>
        <ion-label>Click on a User to select</ion-label>
      </ion-item>
      <ion-grid>
        <ion-row>
          <div *ngFor="let vehicle of vehicleList;">
            <ion-col
              class="grid-block"
              (click)="onVehicleSelect($event,vehicle)"
            >
              <div *ngIf="vehicle?.VendorVehiclePictureContent_GUID != ''">
                <img
                  class="media-thumbnail-img"
                  style="padding: 20px; padding-bottom: 5px"
                  (error)="globals.onThumbnailError($event,'blank.jpg')"
                  src="{{globals.GetXRSCustomContentURL() + 'Thumbnails/' + vehicle?.VendorVehiclePictureContent_GUID + '.jpg'}}"
                />
              </div>

              <div
                style="
                  padding: 20px;
                  padding-top: 0px;
                  padding-bottom: 5px;
                  width: 200px;
                "
              >
                <ion-label style="font-weight: bold; width: 30px"
                  >{{vehicle.Make}}</ion-label
                ><br />
                <ion-label style="font-weight: bold; width: 30px"
                  >{{vehicle.Model}}</ion-label
                ><br />
                <ion-label style="font-weight: bold; width: 30px"
                  >{{vehicle.RegistrationNo}}</ion-label
                ><br />
                <ion-label style="font-weight: bold; width: 30px"
                  >{{vehicle.Kilometers}}</ion-label
                ><br />
              </div>
            </ion-col>
          </div>
        </ion-row>
      </ion-grid>
      <ion-row>
        <ion-col class="modal-ion-col-bottom-buttons" style="left: 0">
          <ion-button
            (click)="onCloseUpload()"
            class="menuitem-ion-button"
            style="width: 110% !important; left: 0"
            >Close</ion-button
          >
        </ion-col>
      </ion-row>
    </div>
  </div>
</ion-content>
